import React from "react";

const OrderDetailsAlert = ({ text, onDismiss }) => (
  <div className="order-details-alert">
    <i className="pi pi-exclamation-triangle" />
    <span className="order-details-alert-text">{text}</span>
    <button
      type="button"
      className="order-details-alert-close"
      onClick={onDismiss}
      aria-label="Close"
    >
      <i className="pi pi-times" />
    </button>
  </div>
);

export default OrderDetailsAlert;

